import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
interface PropertyDetailsProps {
  property: {
    price: number;
    areaUtil?: number;
    areaConstruida?: number;
    areaTotal?: number;
    area?: number;
    size?: number;
    condominium?: number;
    iptu?: number;
    finalidade?: string;
  };
  investmentProjection?: {
    valueIncrease: number;
    years: number;
  };
  priceVsAvg: {
    percentage: string;
    isBelowAvg: boolean;
  };
}
const PropertyDetails: React.FC<PropertyDetailsProps> = ({
  property,
  investmentProjection = {
    valueIncrease: 0,
    years: 0
  },
  priceVsAvg
}) => {
  const getPropertyAreaInfo = () => {
    if (property.areaUtil) return {
      value: property.areaUtil,
      label: 'Área útil'
    };
    if (property.areaConstruida) return {
      value: property.areaConstruida,
      label: 'Área construída'
    };
    if (property.areaTotal) return {
      value: property.areaTotal,
      label: 'Área total'
    };
    return {
      value: property.area || property.size || 0,
      label: 'Área'
    };
  };
  const areaInfo = getPropertyAreaInfo();
  return <Card className="shadow-sm border border-gray-100">
      <CardContent className="p-6">
        <h3 className="text-xl font-semibold mb-4">Resumo da Análise</h3>
        
        <div className="space-y-2">
          {/* Tipo de Negócio */}
          {property.finalidade && <div className="flex items-center justify-between py-2 border-b border-gray-100">
              <span className="text-gray-600">Tipo</span>
              <span className="capitalize text-gray-600">{property.finalidade}</span>
            </div>}

          {/* Preço */}
          <div className="flex items-center justify-between py-2 border-b border-gray-100">
            <span className="text-gray-600">Preço</span>
            <span className="text-gray-600">
              {property.price.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            })}
            </span>
          </div>

          {/* Preço por m² */}
          <div className="flex items-center justify-between py-2 border-b border-gray-100">
            <span className="text-gray-600">Preço / m²</span>
            <span className="text-gray-600">
              {(property.price / areaInfo.value).toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            })}
            </span>
          </div>

          {/* Área */}
          <div className="flex items-center justify-between py-2 border-b border-gray-100">
            <span className="text-gray-600">{areaInfo.label}</span>
            <span className="text-gray-600">{areaInfo.value} m²</span>
          </div>
          
          {/* Áreas adicionais */}
          {property.areaUtil && areaInfo.label !== 'Área útil' && <div className="flex items-center justify-between py-2 border-b border-gray-100">
              <span className="text-gray-600">Área útil</span>
              <span className="text-gray-600">{property.areaUtil} m²</span>
            </div>}
          {property.areaConstruida && areaInfo.label !== 'Área construída' && <div className="flex items-center justify-between py-2 border-b border-gray-100">
              <span className="text-gray-600">Área construída</span>
              <span className="text-gray-600">{property.areaConstruida} m²</span>
            </div>}
          {property.areaTotal && areaInfo.label !== 'Área total' && <div className="flex items-center justify-between py-2 border-b border-gray-100">
              <span className="text-gray-600">Área total</span>
              <span className="text-gray-600">{property.areaTotal} m²</span>
            </div>}

          {/* Preço vs. Média */}
          <div className="flex items-center justify-between py-2 border-b border-gray-100">
            <span className="text-gray-600">Preço vs. Média</span>
            <span className={` ${priceVsAvg.isBelowAvg ? 'text-green-500' : 'text-red-500'}`}>
              {priceVsAvg.isBelowAvg ? '-' : '+'}{Math.abs(parseFloat(priceVsAvg.percentage))}%
            </span>
          </div>

          {/* Custos adicionais */}
          {property.condominium > 0 && <div className="flex items-center justify-between py-2 border-b border-gray-100">
              <span className="text-gray-600">Condomínio</span>
              <span className="text-gray-600">
                {property.condominium.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}
              </span>
            </div>}
          
          {property.iptu > 0 && <div className="flex items-center justify-between py-2 border-b border-gray-100">
              <span className="text-gray-600">IPTU</span>
              <span className="text-gray-600">
                {property.iptu.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}
              </span>
            </div>}
        </div>
      </CardContent>
    </Card>;
};
export default PropertyDetails;